import { CentroCusto } from './../../model/financeiro/centroCusto';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { GenericService } from '../generics/generic.service';

@Injectable({
  providedIn: 'root'
})
export class CentroCustoService extends GenericService<CentroCusto>{
  constructor(http: HttpClient) { 
    super(http);
    super.initResource("centrocusto")
  }
}
